import { objectSchema, ObjectSchema } from "utils/object-methods";
import { ConsigCLTParcelaProps, EmprestimoConsignadoCLTProps } from ".";
import { fieldValidation } from "utils/field-validation";
import { Attendance } from "components/atendimentos-components/atendimento-form/types";
import { revisarCamposComErrors } from "../simulacao-fields/utils";
import { AttendanceActionsTypes } from "contexts/attendance-context/actions-reducer";
import { Dispatch } from "react";
import { CustomTableColorColumn } from "components/dynamic-table/color-table";
import { Checkbox } from "components/checkbox";
import { WarningIcon } from "components/vectors/warning-icon";
import { Box, Flex, Tooltip } from "@chakra-ui/react";

export function validateSimulacaoConsignadoCLT(
  fields: Partial<EmprestimoConsignadoCLTProps>,
  dispatch: Dispatch<AttendanceActionsTypes>
) {
  const attendanceFieldErrors = new Map<keyof Attendance, { name: string }>([]);

  const schema: ObjectSchema<EmprestimoConsignadoCLTProps> = {
    banco: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    codeTable: (value) => {
      if (fields.banco === "TWO_S_CONSIG") return { valid: true };
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    cpf: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      if (!isValid) {
        attendanceFieldErrors.set("cpf", { name: "CPF" });
      }
      return { valid: isValid };
    },
    numberInstallments: (value) => {
      return { valid: true };
      // const { isValid } = fieldValidation({ value }).required();
      // return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    observacao: (value) => {
      return { valid: true, format: null };
    },
    optionValue: (value) => {
      return { valid: true };
    },
    value: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return {
        valid: fields.optionValue === 1 ? isValid : true,
        message: "Preencha o campo corretamente"
      };
    },
    valueInstallment: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return {
        valid: fields.optionValue === 2 ? isValid : true,
        message: "Preencha o campo corretamente"
      };
    },
    simulatedCodeTable: () => ({ valid: true, format: undefined })
  };

  if (attendanceFieldErrors.size) {
    revisarCamposComErrors(attendanceFieldErrors, dispatch);
  }

  return objectSchema(schema, fields);
}

export function setParcelasCLTConsig(
  newValue: ConsigCLTParcelaProps,
  onChangeField: (
    field: keyof EmprestimoConsignadoCLTProps | "parcelas",
    value: any
  ) => void,
  fields: Partial<
    EmprestimoConsignadoCLTProps & {
      parcelas?: ConsigCLTParcelaProps[];
    }
  >
) {
  onChangeField(
    "parcelas",
    fields.parcelas?.map((p) => {
      if (p.id === newValue.id) {
        if (newValue.checked) {
          onChangeField(
            fields.banco === "TWO_S_CONSIG"
              ? "codeTable"
              : "numberInstallments",
            fields.banco === "TWO_S_CONSIG"
              ? newValue.codigoTabela
              : newValue.prazo
          );
        } else {
          onChangeField(
            fields.banco === "TWO_S_CONSIG"
              ? "codeTable"
              : "numberInstallments",
            null
          );
        }
        return newValue;
      }
      return { ...p, checked: false };
    })
  );
}

export function getEmprestimoConsignadoCLTColumns({
  fields,
  onChangeField,
  isDisabledDigitar
}: {
  onChangeField: (
    field: keyof EmprestimoConsignadoCLTProps | "parcelas",
    value: any
  ) => void;
  fields: Partial<
    EmprestimoConsignadoCLTProps & {
      parcelas?: ConsigCLTParcelaProps[];
    }
  >;
  isDisabledDigitar: boolean;
}): CustomTableColorColumn<ConsigCLTParcelaProps>[] {
  return [
    {
      name: "",
      render: (row) => {
        return (
          <Flex align="center">
            <Checkbox
              isChecked={row.checked}
              mr="8px"
              onChange={(is) =>
                setParcelasCLTConsig(
                  { ...row, checked: is },
                  onChangeField,
                  fields
                )
              }
            />

            {/* {isDisabledDigitar && row.checked && (
              <Tooltip
                label="É necessário consultar novamente para fazer a digitação"
                bg="white"
                border="1px solid var(--chakra-colors-custom-gray)"
                color="prymary.500"
                boxShadow="none"
                borderRadius="10px"
              >
                <Box transform="translateY(-2px)">
                  <WarningIcon width="18px" height="18px" color="orange" />
                </Box>
              </Tooltip>
            )} */}
          </Flex>
        );
      }
    },
    {
      name: "Nome Tabela",
      render: (row) => {
        return row.nomeTabela;
      }
    },
    {
      name: "Prazo",
      render: (row) => {
        return row.prazo;
      }
    },
    {
      name: "Valor parcela",
      render: (row) => {
        return row.valorParcela ? `R$ ${row.valorParcela.toFixed(2)}` : null;
      }
    },
    {
      name: "Valor liberado",
      render: (row) => {
        return row.valorLiberado ? `R$ ${row.valorLiberado.toFixed(2)}` : null;
      }
    }
  ];
}
